import type { Attribute, StoreValues, UpdateSectionAttribute, Value } from '@/features/c-form/AttributeRenderer';

/**
 * displayOrder を使って特定セクションだけに絞り込んだ StoreValues を構築。
 *
 * c-form/AttributeRenderer は sectionKey のみでセクションを識別するため、
 * 同一 sectionKey で複数セクションが存在する場合
 * displayOrder で対象を1つに絞る必要がある。
 */
export function buildFilteredStoreValues(sections: StoreValues['sections'], sectionKey: string, displayOrder: number): StoreValues {
  const target = sections.find(s => s.sectionKey === sectionKey && s.displayOrder === displayOrder);
  return {
    sections: target ? [target] : []
  };
}

/**
 * displayOrder 付きの更新関数を c-form/AttributeRenderer 互換のシグネチャに変換
 */
export function buildAdaptedUpdateFn(originalUpdate: (sectionKey: string, displayOrder: number, attributeKey: string, value: Value, displayValue?: string | null) => void, displayOrder: number): UpdateSectionAttribute {
  return (sectionKey, attributeKey, value, displayValue) => {
    originalUpdate(sectionKey, displayOrder, attributeKey, value, displayValue);
  };
}

/**
 * 属性配列を AttributeRenderer 互換の Attribute[] に変換。
 * 両型は同一 Section/Attribute スキーマから導出されるため構造的に互換。
 */
export function toRendererAttributes(attrs: ReadonlyArray<Record<string, unknown>>): Attribute[] {
  return attrs as Attribute[];
}